import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { GlobalService } from './global.service';
import { SharedHeader } from '@models/shared-header';
import { environment } from '@environment';

@Injectable({
    providedIn: 'root'
})
export class SharedService {
    constructor(
        private http: HttpClient,
        private globalService: GlobalService
    ) {}

    getHeader(id: string): Observable<SharedHeader> {
        const params: HttpParams = new HttpParams({ fromObject: { language: this.globalService.getLanguage() } });
        return this.http.get<SharedHeader>(`${environment.ApiBase}master/shared/header/${id}`,{ params: params });
    }
}
